import { saveEditStructurePageTransferData } from "@src/cloud-connect/node-manager/node-manager-repository";
import { updateEditStructurePageTransferDataFiltered } from "@src/reducers/your-reducer";
import store from "@src/reducers/store";

// This is a helper function to remove a node from array by its key
const removeNodeByKey = (nodes, targetKey) =>
  nodes.filter((node) => node.key !== targetKey);

// New version of filterSelectedNodes function
export const filterSelectedNodes = (node) => {
  const newNode = { ...node };

  if (newNode.children) {
    newNode.children = newNode.children.map((child) =>
      filterSelectedNodes(child),
    );

    const selectedChildren = newNode.children.filter((child) => child.selected);

    for (const child of selectedChildren) {
      // Move child's non-selected children up to current node
      if (child.children) {
        newNode.children = [
          ...newNode.children,
          ...child.children.filter((grandchild) => !grandchild.selected),
        ];
      }
      // Remove the selected child node
      newNode.children = removeNodeByKey(newNode.children, child.key);
    }
  }

  return newNode;
};

const buildObjectAfterDeletion = (nodeData, rootNode) => {
  return {
    ...nodeData,
    nodeset: {
      ...nodeData.nodeset,
      root_node: rootNode,
    },
  };
};

export const deleteNodes = (transferedNodeData, filteredTransferedNodeData) => {
  if (transferedNodeData !== undefined) {
    const rootNode = filterSelectedNodes(transferedNodeData.nodeset.root_node);

    if (rootNode === null || rootNode.children.length === 0) {
      saveEditStructurePageTransferData(undefined);
      store.dispatch(updateEditStructurePageTransferDataFiltered(undefined));
    } else {
      saveEditStructurePageTransferData(
        buildObjectAfterDeletion(transferedNodeData, rootNode),
      );

      if (filteredTransferedNodeData) {
        const filteredRootNode = filterSelectedNodes(
          filteredTransferedNodeData.nodeset.root_node,
        );

        store.dispatch(
          updateEditStructurePageTransferDataFiltered(
            buildObjectAfterDeletion(
              filteredTransferedNodeData,
              filteredRootNode,
            ),
          ),
        );
      }
    }
  }
};
